var SpriteSymbol = require("../../node_modules/svg-baker-runtime/browser-symbol.js");
var sprite = require("../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js");
var symbol = new SpriteSymbol({
  "id": "checkmark_payment",
  "use": "checkmark_payment-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"checkmark_payment\">\n    <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M0 12C0 5.382 5.382 0 12 0C18.618 0 24 5.382 24 12C24 18.618 18.618 24 12 24C5.382 24 0 18.618 0 12ZM10.386 17.262C10.728 17.262 11.055 17.124 11.298 16.884L19.242 8.94L17.418 7.116L10.386 14.148L6.582 10.344L4.758 12.168L9.474 16.884C9.717 17.124 10.044 17.262 10.386 17.262Z\" fill=\"#8529FF\" />\n</symbol>"
});
var result = sprite.add(symbol);
module.exports = symbol